import StandardConfirmationModal from "../standard-confirmation";
import { FC } from "react";

interface UnblockUserModalProps extends StandardModalProps {
  onConfirm: () => void;
  name?: string;
  loading: boolean;
  description?: string;
}

const UnblockUserModal: FC<UnblockUserModalProps> = ({
  open,
  onClose,
  onConfirm,
  name,
  loading,
  description = "partner",
}) => {
  return (
    <StandardConfirmationModal
      open={open}
      onClose={onClose}
      maxWidth="xs"
      onConfirm={onConfirm}
      title={`Unblock "${name}"`}
      description={`Are you sure you want to unblock this ${description}? This action cannot be undone.`}
      confirmButtonColor="success"
      confirmButtonTitle="Confirm"
      confirmButtonLoader={loading}
    />
  );
};

export default UnblockUserModal;
